import { WS_FS_DELETE_TELEMETRY_EVENT_NAME } from './ws-fs-delete-telemetry.constants';
export const createWsFsDeleteEventPayload = ({ deletionReasons, filespaceId, otherDeletionReason, workspaceId, }) => ({
    name: WS_FS_DELETE_TELEMETRY_EVENT_NAME,
    data: {
        workspaceId,
        ...(filespaceId && { filespaceId }),
        customData: {
            deletionReasons,
            ...(otherDeletionReason && { otherDeletionReason }),
        },
    },
});
